// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1-8T4","head":"Table_head__2N0H4","col":"Table_col__tzuMh"};